import React from 'react'
import { FormattedMessage } from 'react-intl'
import * as routes from 'core/routing/constants'
import View1 from './view1'
import View2 from './view2'

const aSteps = [
  {
    hash: routes.THEMING_VIEW_1,
    title: <FormattedMessage id="theming-wizard-title-1" />,
    component: <View1 />,
    nextButtonText: <FormattedMessage id="theming-wizard-view1-nextButton" />
  },
  {
    hash: routes.THEMING_VIEW_2,
    title: <FormattedMessage id="theming-wizard-title-2" />,
    component: <View2 />,
    backButtonText: <FormattedMessage id="theming-wizard-view2-backButton" />
  }
]

export default aSteps
